/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FieldInfo } from '../map/map.component';

export enum TRACK_ACTION {
  SHOW_ON_MAP = 'SHOW_ON_MAP',
  OPEN_FROM_MAP = 'OPEN_FROM_MAP',
  OPEN_FROM_LIST = 'OPEN_FROM_LIST',
  OPEN_FROM_LANDING = 'OPEN_FROM_LANDING',
  OPEN_MAP_FROM_LANDING = 'OPEN_MAP_FROM_LANDING',
  OPEN_FILTERS = 'OPEN_FILTERS',
  SET_FILTER = 'SET_FILTER',
  BOOK = 'BOOK',
  OPEN_RENTAL_REQUEST_MODAL = 'OPEN_RENTAL_REQUEST_MODAL',
}

export enum LANDING_ACTIONS {
  FIRST_ACTION = 'FIRST_ACTION',
  SECOND_ACTION = 'SECOND_ACTION',
  THIRD_ACTION = 'THIRD_ACTION',
}

export interface RentalRequestData {
  name: string;
  userPhone: string;
  fieldPhone: string;
  date: string;
  address: string;
  fieldTitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private http: HttpClient) {}

  trackAction(
    action: TRACK_ACTION,
    data?: FieldInfo | string | LANDING_ACTIONS
  ) {
    if (
      !window.location.href.includes('localhost') &&
      !window.location.href.includes('test')
    ) {
      switch (action) {
        // case TRACK_ACTION.BOOK:
        //   return this.track_fieldOrder(data as FieldInfo);
        case TRACK_ACTION.OPEN_FILTERS:
          return this.track_openFilters();
        case TRACK_ACTION.SET_FILTER:
          return this.track_setFilter(data as string);
        case TRACK_ACTION.SHOW_ON_MAP:
          return this.track_showFieldOnMap(data as FieldInfo);
        case TRACK_ACTION.OPEN_FROM_MAP:
          return this.track_openFieldFromMap(data as FieldInfo);
        case TRACK_ACTION.OPEN_FROM_LANDING:
          return this.track_openFieldFromLanding(data as FieldInfo);
        case TRACK_ACTION.OPEN_FROM_LIST:
          return this.track_openFieldFromList(data as FieldInfo);
        case TRACK_ACTION.OPEN_MAP_FROM_LANDING:
          return this.track_openMapFromLanding(data as LANDING_ACTIONS);
        case TRACK_ACTION.OPEN_RENTAL_REQUEST_MODAL:
          return this.track_openRentalRequestModal(data as FieldInfo);
        case TRACK_ACTION.BOOK:
          return this.track_fieldOrder(data as FieldInfo);
      }
    } else {
      console.log('track in dev:', action, data);
      return new Observable();
    }
  }

  sendFeedback(email: string, text: string) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'feedback',
          actionId: email,
          projectName: 'rentland',
          additionalInfo: text,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  sendRentalRequest(rentalRequest: RentalRequestData) {
    const { date, name, userPhone, fieldPhone, address } = rentalRequest;
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'booking',
          actionId: rentalRequest.fieldTitle,
          projectName: 'rentland',
          additionalInfo: {
            name,
            date,
            userPhone: userPhone.trim().replace('(', '').replace(')', ''),
            address,
            fieldPhone: fieldPhone.trim().replace('(', '').replace(')', ''),
          },
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_fieldOrder(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'book',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openFilters() {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_filters',
          actionId: 'filters',
          projectName: 'rentland',
          additionalInfo: 'none',
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_setFilter(filterName: string) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'set_filter',
          actionId: filterName,
          projectName: 'rentland',
          additionalInfo: 'none',
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_showFieldOnMap(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'show_field_on_map',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openFieldFromMap(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_field_from_map',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openFieldFromLanding(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_field_from_landing',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openMapFromLanding(data: LANDING_ACTIONS) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_map_from_landing',
          actionId: data,
          projectName: 'rentland',
          additionalInfo: data,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openRentalRequestModal(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_rental_request_modal',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }

  private track_openFieldFromList(fieldInfo: FieldInfo) {
    return this.http.post(
      'https://r71vanixn0.execute-api.eu-central-1.amazonaws.com/Prod',
      {
        data: {
          action: 'open_field_from_list',
          actionId: fieldInfo.title,
          projectName: 'rentland',
          additionalInfo: `${fieldInfo.priceFrom}, ${fieldInfo.priceTo}`,
          userEmail: localStorage.getItem('userId'),
        },
      }
    );
  }
}
